import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#e90a7d',
        secondary: '#6c757d',
        accent: '#3ea2fb',
        error: '#dc3545',
        petrol: '#1565C0',
        background: '#eee',
        header: '#435058'
      },
      dark: {
        primary: '#e90a7d',
        secondary: '#6c757d',
        accent: '#3ea2fb',
        error: '#dc3545',
        petrol: '#1565C0',
        background: '#242424',
        header: '#435058'
      }
    },
    options: {
      customProperties: true
    }
  }
})
